import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';

import AddToCartButton from './AddToCartButton';
import CartMini from './CartMini';
import Quickshop from './Quickshop';

export default class ProductItem {
  constructor(el) {
    this.el = el;
    this.cartMini = new CartMini();
    this.quickshopTrigger = this.el.querySelector('[data-product-card-interaction-quickshop]');
    this.addToCartTrigger = this.el.querySelector('[data-product-card-interaction-addtocart]');

    this.el.querySelectorAll('.money:not([data-currency])')
      .forEach(money => CurrencyConverter.update(money));

    if (this.quickshopTrigger) {
      this.quickshopProductUrl = this.quickshopTrigger.getAttribute('data-product-url');
      this.quickshopProductSha256 = this.quickshopTrigger.getAttribute('data-product-sha256');
      this.quickshop = new Quickshop();

      $(this.quickshopTrigger).on('click', (event) => {
        event.preventDefault();
        this.quickshop.open(
          this.quickshopProductUrl,
          this.quickshopProductSha256,
        );
      });
    }

    if (this.addToCartTrigger) {
      this.addToCartButton = new AddToCartButton(this.addToCartTrigger);
      this.addToCartVariantId = this.addToCartTrigger.getAttribute('data-product-variant-id');

      $(this.addToCartTrigger).on('click', (event) => {
        event.preventDefault();
        this.addToCartButton.setState('loading');

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: this.addToCartVariantId,
            quantity: 1,
          },
          success: () => {
            this.cartMini.refresh();
            setTimeout(() => {
              this.addToCartButton.setState('success');
              this.cartMini.open();
              setTimeout(() => this.addToCartButton.resetState(), 1000);
            }, 1000);
          },
          error: () => setTimeout(() => {
            this.addToCartButton.setState('error');
            setTimeout(() => this.addToCartButton.resetState(), 1000);
          }, 1000),
          dataType: 'json',
        });
      });
    }


  }

  unload() {
    $('[data-product-card-interaction-quickshop]', this.el).off('click');
    $('[data-product-card-interaction-addtocart]', this.el).off('click');

    if (this.addToCartButton) {
      this.addToCartButton.resetState();
    }
    this.addToCartButton = null;
  }
}
